import { Component } from 'react';

// Pages chargées à la demande (React.lazy). Après une mise en ligne, un
// onglet resté ouvert réclame des fichiers qui n'existent plus : on recharge
// alors la page une fois pour obtenir la nouvelle version, et si l'échec
// persiste, un message remplace la page blanche.
export const RELOAD_KEY = 'lazy-page-reloaded';

const storage = {
    get: () => { try { return sessionStorage.getItem(RELOAD_KEY); } catch { return null; } },
    set: () => { try { sessionStorage.setItem(RELOAD_KEY, '1'); } catch { /* indisponible */ } },
    clear: () => { try { sessionStorage.removeItem(RELOAD_KEY); } catch { /* indisponible */ } },
};

export const loadOrReload = (load, reload = () => window.location.reload()) => load().then(
    page => {
        storage.clear();
        return page;
    },
    error => {
        if (storage.get()) throw error; // déjà rechargée : pas de boucle
        storage.set();
        reload();
        return new Promise(() => {}); // la page se recharge
    },
);

export class PageLoadBoundary extends Component {
    state = { failed: false };

    static getDerivedStateFromError() {
        return { failed: true };
    }

    componentDidCatch(error) {
        console.error('Page non chargée :', error);
    }

    render() {
        if (!this.state.failed) return this.props.children;
        return (
            <div className="page-load-error" role="alert">
                <p>Cette page n'a pas pu se charger.</p>
                <button type="button" className="btn-view" onClick={() => window.location.reload()}>
                    Recharger la page
                </button>
            </div>
        );
    }
}
